import { useMemo, type FC } from "react";

import { HeaderDivider } from "@/components/app-header/AppHeaderShell";
import { Button } from "@/components/ui/button";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "@/components/ui/tooltip";
import {
  useRegisterActiveTab,
  type ActiveTabRegistration
} from "@/features/appTabs/context/ActiveTabContext";
import { ONBOARDING_TAB_ID } from "@/features/appTabs/tabRoutes";

const FinishLater: FC<{ onFinishLater: () => void }> = ({ onFinishLater }) => (
  <>
    <HeaderDivider />
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          onClick={onFinishLater}
          data-testid="onboarding-finish-later"
        >
          Finish Setup Later
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">
        Your progress is saved. Pick up anytime from the Get Started checklist.
      </TooltipContent>
    </Tooltip>
  </>
);

/** Puts Finish Setup Later into the app header while onboarding is open. */
export const OnboardingHeader: FC<{ onFinishLater: () => void }> = ({
  onFinishLater
}) => {
  const reg = useMemo<ActiveTabRegistration>(
    () => ({
      tabId: ONBOARDING_TAB_ID,
      actions: <FinishLater onFinishLater={onFinishLater} />
    }),
    [onFinishLater]
  );
  useRegisterActiveTab(reg);
  return null;
};
